export type ChecklistRecord = {
  _id: string;
  formData: any;
  title: string;
  author: string;
  createdAt: string;
  updatedAt: string;
};

export type LoginResponse = {
  username: string;
  fullName: string;
};

export async function listChecklists(limit = 10): Promise<ChecklistRecord[]> {
  const res = await fetch(`/api/checklists?limit=${limit}`);
  if (!res.ok) throw new Error('Failed to fetch checklists');
  return res.json();
}

export async function getChecklist(id: string): Promise<ChecklistRecord> {
  const res = await fetch(`/api/checklists/${id}`);
  if (!res.ok) throw new Error('Checklist not found');
  return res.json();
}

export async function createChecklist(payload: { formData: any; author: string; title: string; }): Promise<ChecklistRecord> {
  const res = await fetch('/api/checklists', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('Failed to create checklist');
  return res.json();
}

export async function login(payload: { username: string; password: string }): Promise<LoginResponse> {
  const res = await fetch('/api/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    try {
      const body = await res.json();
      throw new Error(body?.error || 'auth failed');
    } catch (e) {
      if (e instanceof Error) throw e;
      throw new Error('auth failed');
    }
  }
  return res.json();
}

export async function deleteChecklist(id: string): Promise<void> {
  const res = await fetch(`/api/checklists/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error('Failed to delete checklist');
}


